/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Image_TimeoutInputs */

const cs_social_export_image_timeout = /** @type {(inputs: Social_Export_Image_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generování obrázku vypršelo — zkuste to znovu.`)
};

const en_social_export_image_timeout = /** @type {(inputs: Social_Export_Image_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image generation timed out — try again shortly.`)
};

/**
* | output |
* | --- |
* | "Image generation timed out — try again shortly." |
*
* @param {Social_Export_Image_TimeoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_image_timeout = /** @type {((inputs?: Social_Export_Image_TimeoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Image_TimeoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_image_timeout(inputs)
	return cs_social_export_image_timeout(inputs)
});